const fieldsConfig = {
    'simple-text': (field) => {
        
        /**
         * SimpleText Rule length have 3 possibilities:
         *  min / max / range
         */
        return {
            value: field.parameters.default_value,
            rules: [
                // min rule
                ...[((field.parameters.char_min && !field.parameters.char_max) && {min: field.parameters.char_min, message: window.i18n.__('Veuillez renseigner au moins %s caractères', field.parameters.char_min)})],
                // max rule
                ...[((!field.parameters.char_min && field.parameters.char_max) && {max: field.parameters.char_max, message: window.i18n.__('Veuillez renseigner au maximum %s caractères', field.parameters.char_max)})],
                // range rule
                ...[((field.parameters.char_min && field.parameters.char_max) && {min: field.parameters.char_min, max: field.parameters.char_max, message: window.i18n.__('Veuillez renseigner entre %(min)s et %(max)s caractères', {min: field.parameters.char_min, max: field.parameters.char_max})})],
                // required rule
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    checkbox: (field) => {
        return {
            value: field.parameters.items.filter(item => item.checked).map(item => item.id),
            rules: [
                // min rule
                ...[((field.parameters.min && !field.parameters.max) && { type: 'array', min: field.parameters.min, message: window.i18n.__('Veuillez sélectionner au moins %s choix', field.parameters.min) })],
                // max rule
                ...[((!field.parameters.min && field.parameters.max) && { type: 'array', max: field.parameters.max, message: window.i18n.__('Veuillez sélectionner au maximum %s choix', field.parameters.max) })],
                // range rule
                ...[((field.parameters.min && field.parameters.max) && { type: 'array', min: field.parameters.min, max: field.parameters.max, message: window.i18n.__('Veuillez sélectionner entre %(min)s et %(max)s choix', { min: field.parameters.min, max: field.parameters.max }) })],
                // required rule
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    boolean: (field) => {
        return {
            value: field.parameters.default_value,
            rules: [
                // required rule
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    radio: (field) => {
        return {
            value: field.parameters.items.find(item => item.checked)?.id || null,
            rules: [
                // required rule
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)  
        }
    },
    select: (field) => {
        return {
            value: field.parameters.items.find(item => item.checked)?.id || null,
            rules: [
                // required rule
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        };
    },
    'rich-text': (field) => {
        return {
            /**
             * Separate content and count value to make it feed by TiptapEditor with next rules
             */
            value: {
                content: !!field.parameters.default_value ? field.parameters.default_value : null,
                count: !!field.parameters.default_value ? field.parameters.default_value.length : 0
            },
            rules: [
                // min rule
                ...[((field.parameters.char_min && !field.parameters.char_max) && {
                    validator(rule, value, callback) {
                        if (value.count < field.parameters.char_min) callback(new Error(window.i18n.__('Veuillez renseigner au moins %s caractères', field.parameters.char_min)))
                        return callback();
                    },
                })],
                // max rule
                ...[((!field.parameters.char_min && field.parameters.char_max) && {
                    validator(rule, value, callback) {
                        if (value.count > field.parameters.char_max) callback(new Error(window.i18n.__('Veuillez renseigner au maximum %s caractères', field.parameters.char_max)))
                        return callback();
                    },
                })],
                // range rule
                ...[((field.parameters.char_min && field.parameters.char_max) && {
                    validator(rule, value, callback) {
                        if (value.count < field.parameters.char_min || value.count > field.parameters.char_max) callback(new Error(window.i18n.__('Veuillez renseigner entre %(min)s et %(max)s caractères', { min: field.parameters.char_min, max: field.parameters.char_max })))
                        return callback();
                    },
                })],
                // required rule
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    'company-individual': field => {
        return {
            value: [],
            rules: [
                { type: 'array', max: field.parameters.number_of_values, message: window.i18n.__('Veuillez sélectionner au maximum %s client/prospect/fournisseur', field.parameters.number_of_values) },
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    'numeric-with-unit': (field, units) => {
        return {
            value: {
                number: !!field.parameters.default_value ? field.parameters.default_value : "0",
                unit_id: !!field.parameters.unit ? units?.find(unit => unit.label === field.parameters.unit)?.id : null
            },
            rules: [
                // min rule
                ...[((field.parameters.min_value && !field.parameters.max_value) && {
                    validator(rule, value, callback) {
                        if (+value.number < +field.parameters.min_value) callback(new Error(window.i18n.__('Veuillez renseigner un nombre supérieur à %s', field.parameters.min_value)))
                        return callback();
                    },
                    trigger: 'submit'
                })],
                // max rule
                ...[((!field.parameters.min_value && field.parameters.max_value) && {
                    validator(rule, value, callback) {
                        if (+value.number > +field.parameters.max_value) callback(new Error(window.i18n.__('Veuillez renseigner un nombre inférieur à %s', field.parameters.max_value)))
                        return callback();
                    },
                    trigger: 'submit'
                })],
                // range rule
                ...[((field.parameters.min_value && field.parameters.max_value) && {
                    validator(rule, value, callback) {
                        if (+value.number < +field.parameters.min_value || +value.number > +field.parameters.max_value) callback(new Error(window.i18n.__('Veuillez renseigner un nombre compris entre %(min)s et %(max)s', { min: field.parameters.min_value, max: field.parameters.max_value })))
                        return callback();
                    },
                    trigger: 'submit'
                })],
                // required rule
                ...[({validator(rule, value, callback) {
                        if (_.isNil(value.unit_id)) {
                            return callback(new Error(window.i18n.__('Veuillez renseigner une unité')))
                        }
                        if (_.isNil(value.number)) {
                            return callback(new Error(window.i18n.__('Veuillez renseigner un nombre')))
                        }
                        return callback();
                    }
                })],
            ].filter(rule => rule)
        }
    },
    amount: field => {
        return {
            value: {
                amount: !!field.parameters.default_value ? field.parameters.default_value : "0",
                currency: field.parameters.currency
            },
            rules: [
                // min rule
                ...[((field.parameters.min_value && !field.parameters.max_value) && {
                    validator(rule, value, callback) {
                        if (+value.amount < +field.parameters.min_value) callback(new Error(window.i18n.__('Veuillez renseigner un montant supérieur à %s', field.parameters.min_value)))
                        return callback();
                    },
                })],
                // max rule
                ...[((!field.parameters.min_value && field.parameters.max_value) && {
                    validator(rule, value, callback) {
                        if (+value.amount > +field.parameters.max_value) callback(new Error(window.i18n.__('Veuillez renseigner un montant inférieur à %s', field.parameters.max_value)))
                        return callback();
                    },
                })],
                // range rule
                ...[((field.parameters.min_value && field.parameters.max_value) && {
                    validator(rule, value, callback) {
                        if (+value.amount < +field.parameters.min_value || +value.amount > +field.parameters.max_value) callback(new Error(window.i18n.__('Veuillez renseigner un montant compris entre %(min)s et %(max)s', { min: field.parameters.min_value, max: field.parameters.max_value })))
                        return callback();
                    },
                })],
                // required rule
                ...[({ 
                    validator(rule, value, callback) {
                        if(_.isNil(value.currency)) {
                            return callback(new Error(window.i18n.__('Veuillez renseigner une devise')))
                        }
                        if (_.isNil(value.amount)) {
                            return callback(new Error(window.i18n.__('Veuillez renseigner un montant')))
                        }
                        return callback();
                    }
                })],
            ].filter(rule => rule)
        }
    },
    contact: field => {
        return {
            value: [],
            rules: [
                { type: 'array', max: field.parameters.number_of_values, message: window.i18n.__('Veuillez sélectionner au maximum %s contacts', field.parameters.number_of_values) },
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    staff: field => {
        return {
            value: [],
            rules: [
                { type: 'array', max: field.parameters.number_of_values, message: window.i18n.__('Veuillez sélectionner au maximum %s collaborateurs', field.parameters.number_of_values) },
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    item: field => {
        return {
            value: [],
            rules: [
                { type: 'array', max: field.parameters.number_of_values, message: window.i18n.__('Veuillez sélectionner au maximum %s produits/services', field.parameters.number_of_values) },
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    numeric: field => {
        return {
            value: field.parameters.default_value,
            rules: [
                // min rule
                ...[((field.parameters.min_value && !field.parameters.max_value) && { type: 'number', min: +field.parameters.min_value, message: window.i18n.__('Veuillez renseigner une valeur supérieur à %s', field.parameters.min_value), transform(value) { return parseFloat(value) } })],
                // max rule
                ...[((!field.parameters.min_value && field.parameters.max_value) && { type: 'number', max: +field.parameters.max_value, message: window.i18n.__('Veuillez renseigner une valeur inférieur à %s', field.parameters.max_value), transform(value) { return parseFloat(value) } })],
                // range rule
                ...[((field.parameters.min_value && field.parameters.max_value) && { type: 'number', min: +field.parameters.min_value, max: +field.parameters.max_value, message: window.i18n.__('Veuillez renseigner une valeur entre %(min)s et %(max)s', { min: field.parameters.min_value, max: field.parameters.max_value }), transform(value) { return parseFloat(value) } })],
                // required rule
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
    email: (field) => {
        return {
            value: field.parameters.default_value,
            rules: [
                { type: 'email', message: window.i18n.__('Veuillez renseigner un email valide') },
                // required rule
                ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
            ].filter(rule => rule)
        }
    },
};

/**
 * 
 * @param {*} field : Single field configuration
 * @returns {object} : Field config with default value and rules
 */
const defaultFieldConfig = field => {
    return {
        value: !!field.parameters.default_value ? field.parameters.default_value : null,
        rules: [
            // required rule
            ...[(field.mandatory && { required: true, message: window.i18n.__('Vous avez oublié de compléter un champs obligatoire') })]
        ].filter(rule => rule)
    }
}
/**
 * 
 * @param {Array} fields 
 * @returns {Array} fields mapped with value and rules for each type
 */
const buildCustomFields = (fields, units) => {
    return fields.map(field => {
        let fieldConfig = null;
        if(field.type === "numeric-with-unit"){
            fieldConfig = !!fieldsConfig[field.type] ? fieldsConfig[field.type](field, units) : defaultFieldConfig(field);
        }else{
            fieldConfig = !!fieldsConfig[field.type] ? fieldsConfig[field.type](field) : defaultFieldConfig(field);
        }
        let customFields = {
            ...field,
            ...fieldConfig
        }
        if(!_.isNil(field) && !_.isNil(field.value)){
            customFields.value = field.value
        }
        return customFields
    });
}
/**
 * 
 * @param {Array} fields 
 * @returns Array of groups fields 
 * [ {group: { id, name }, fields: [{...}] }]
 */
const getCustomFieldsByGroup = (fields) => {
    return _.map(_.groupBy(fields, 'customfield_group.id'), ((fields, id) => {
        return ({ id, name: fields[0].customfield_group.name, fields });
    }));
}

export {
    buildCustomFields, 
    getCustomFieldsByGroup
}